<template>
  <div class="shared">
    <div class="shared__header">
      <a :href="$baseURL" class="shared__header__logo"></a>
    </div>
    <div class="shared__panel">
      <div class="shared__panel__headline">
        <h2 class="shared__panel__headline__title">
          {{ !title ? "Wait..." : title }}
        </h2>

        <div class="shared__panel__headline__buttons">
          <BaseButton
            class="shared__panel__headline__buttons__download-item"
            :viewType="'white'"
            :disabled="!isSomeChecked || isDownloading"
            style="margin-right: 8px"
            @click.native="downloadCheckedItems"
          >
            <div class="icon" style="margin-right: 12px"></div>
            Download</BaseButton
          >
          <BaseButton
            class="shared__panel__headline__buttons__download-all"
            :disabled="!isAllReady || isDownloading"
            @click.native="downloadArchive"
          >
            <div class="icon" style="margin-right: 12px"></div>
            Download All</BaseButton
          >
        </div>
      </div>
      <div class="shared__panel__video-container">
        <div
          class="shared__panel__video-container__item"
          v-for="file in files"
          :key="file.id"
          :class="{
            _checked: file.checked,
            _hover: file.id === hoverId && file.ready,
          }"
          @click="handleClick(file)"
          @mouseover="onMouseOver(file)"
          @mouseleave="onMouseLeave(file)"
          :title="file.name"
        >
          <div
            class="shared__panel__video-container__item__image-container"
            :class="{ _disabled: !file.ready }"
          >
            <img
              v-if="file.ready"
              class="shared__panel__video-container__item__image-container__thumb"
              :src="$baseURL + file.thumbs"
              alt=""
            />
            <div
              class="icon"
              :class="{ 'circle-loader': !file.ready, _play: file.ready }"
            ></div>
          </div>
          <p class="shared__panel__video-container__item__title">
            {{ file.name }}
          </p>
        </div>
      </div>
    </div>

    <RendersPreviewWindow
      v-if="isOpenRenderPreview"
      :files="files.filter((i) => i.ready)"
      :initialItem="firstPreviewItem"
      @close="handleCloseRendersPreview"
    ></RendersPreviewWindow>
  </div>
</template>

<script>
import "@/app/store/index";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import RendersPreviewWindow from "@/app/modules/shared/windows/RendersPreviewWindow";

export default {
  name: "Login",
  components: { BaseButton, RendersPreviewWindow },
  data: function () {
    return {
      isSignUp: true,
      agreeWithTerms: true,
      isLoading: true,
      isDownloading: false,
      title: null,
      files: [],
      timerClick: null,
      isDoubleClick: false,
      hoverId: null,
      isOpenRenderPreview: false,
      firstPreviewItem: null,
    };
  },
  computed: {
    isSomeChecked: function () {
      return this.files.some((i) => i.checked);
    },
    isAllReady: function () {
      return this.files.length !== 0 && this.files.every((i) => i.ready);
    },
  },
  created() {
    document.querySelector("body").classList.add("scroll");
    this.getSharedFiles();
  },
  methods: {
    handleCloseRendersPreview() {
      this.isOpenRenderPreview = false;
    },
    onMouseOver(file) {
      this.hoverId = file.id;
    },
    onMouseLeave() {
      this.hoverId = null;
    },
    getSharedFiles() {
      this.axios
        .post(
          "/utils/getSharedFiles",
          { hash: `${this.$route.params.sharedId}` },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (
            this.files.length !== 0 &&
            this.files.length === response.data.assets.length
          ) {
            response.data.assets.forEach(
              (i) =>
                (this.files.find((file) => file.id === i.id).ready = i.ready)
            );
          } else {
            response.data.assets.forEach((i) =>
              this.files.push({ ...i, checked: false })
            );
            this.title = `Creative Studio ${response.data.assets[0].createdAt.slice(
              0,
              10
            )}`;
          }
          if (this.files.some((i) => !i.ready)) {
            setTimeout(() => {
              this.getSharedFiles();
            }, 5000);
          }
        })
        .catch((error) => {
          this.title = "Error 404: Page not found";
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleClick(file) {
      if (this.isClick) {
        clearInterval(this.timerClick);
        this.isClick = false;
        this.openVideo(file);
        return null;
      }
      this.isClick = true;
      this.timerClick = setTimeout(() => {
        this.checkItem(file);
        this.isClick = false;
        clearInterval(this.timerClick);
      }, 200);
    },
    checkItem(file) {
      if (!file.ready) {
        return null;
      }
      if (!file.checked) {
        file.checked = true;
      } else {
        file.checked = false;
      }
    },
    openVideo(file) {
      if (!file.ready) {
        return null;
      }
      this.isOpenRenderPreview = true;
      this.firstPreviewItem = file;
    },
    downloadFile(file) {
      let downloadHref = file.downloadPath;
      let link = document.createElement("a");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.download = file.name;
      link.href = downloadHref;
      link.click();
      document.body.removeChild(link);
    },
    downloadZip(path) {
      let downloadHref = path;
      let link = document.createElement("a");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.download = this.title;
      link.href = downloadHref;
      link.click();
      document.body.removeChild(link);
    },
    downloadCheckedItems() {
      if (!this.isSomeChecked || this.isDownloading) {
        return null;
      }
      const checkedFiles = this.files.filter((i) => i.checked);

      if (checkedFiles.length > 10) {
        this.downloadArchive(checkedFiles.map((i) => i.id));
      } else {
        this.isDownloading = true;
        checkedFiles.forEach((ic) => {
          this.downloadFile(ic);
        });
        setTimeout(() => {
          this.isDownloading = false;
        }, 5000);
      }
    },
    downloadArchive(ids) {
      if (this.isDownloading) {
        return null;
      }
      let idsToSend;

      if (!ids) {
        if (!this.isAllReady) {
          return null;
        }
        idsToSend = this.files.map((i) => i.id);
      } else {
        idsToSend = ids;
      }

      this.isDownloading = true;
      this.axios
        .post(
          "/utils/createArchiveShared",
          {
            hash: `${this.$route.params.sharedId}`,
            ids: idsToSend,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.downloadZip(response.data.archive);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.isDownloading = false;
          }, 5000);
        });
    },
  },
};
</script>

<style lang="scss">
.shared {
  width: 100%;
  height: 100%;
  background-color: $color-font-basic;

  display: flex;
  flex-direction: column;

  &__header {
    flex: 0 0 62px;

    display: flex;
    align-items: center;

    height: 62px;

    border-width: 0;
    border-bottom-width: 1px;
    border-style: solid;
    border-color: $color-gray-8;

    &__logo {
      margin-left: 28px;

      width: 78px;
      height: 22px;

      background-image: url("~assets/roasup-logo-dark.svg");
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
  &__panel {
    flex: 1 1 auto;
    overflow: hidden;

    display: flex;
    flex-direction: column;

    &__headline {
      flex: 0;

      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 40px 80px 0 80px;

      &__title {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 32px;
        line-height: 40px;
        color: black;
      }

      &__buttons {
        &__download-item {
          min-height: 36px;
          min-width: 124px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);

          .icon {
            min-height: 16px;
            min-width: 16px;
            @include mask-image(
              url("~assets/new-icons/download-icon.svg"),
              inherit,
              16px
            );
          }
        }

        &__download-all {
          min-height: 36px;
          min-width: 151px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);

          .icon {
            min-height: 16px;
            min-width: 16px;
            @include mask-image(
              url("~assets/new-icons/download-icon.svg"),
              inherit,
              16px
            );
          }
        }
      }
    }

    &__video-container {
      flex: 1 1 auto;
      overflow-y: scroll;

      display: grid;
      margin: 40px 0 0 0;
      padding: 0 80px 0 80px;
      grid-template-columns: repeat(auto-fit, 210px);
      grid-row-gap: 26px;
      grid-column-gap: 26px;

      &__item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 210px;
        height: 213px;

        &._hover {
          background: #f5f5f5;
          cursor: pointer;
        }

        &._checked {
          background: #f5f5f5;
        }

        &__image-container {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          height: 146px;
          width: 146px;
          border-radius: 4px;

          &._disabled {
            background: #f5f5f5;
          }

          &__thumb {
            height: 100%;
            width: 100%;
            object-fit: contain;
          }

          .icon {
            position: absolute;

            &.circle-loader {
              height: 58px;
              width: 58px;
              border-width: 3px;
            }

            &._play {
              height: 26px;
              width: 26px;
              opacity: 0.5;
              @include mask-image(
                url("~assets/new-icons/play-icon.svg"),
                white,
                26px
              );

              &:hover {
                opacity: 1;
              }
            }
          }
        }

        &__title {
          max-width: 75%;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 11px 0 0 0;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          line-height: 16px;
          color: $color-gray-3;
          user-select: none;
        }
      }
    }
  }
}
.scroll::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

.scroll::-webkit-scrollbar-track {
  background: $color-gray-9;
}

.scroll::-webkit-scrollbar-thumb {
  background: $color-gray-7;
  border-radius: 10px;
}
</style>
